
export default (v) => `${v.slice(4, v.length)}/${v.slice(2, 4)}`;

